var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.showEmailSent)?_c('forgot-password',{on:{"show-email":function($event){_vm.showEmailSent = true}}}):_vm._e(),(_vm.showEmailSent)?_c('email-sent',{on:{"show-email":function($event){_vm.showEmailSent = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }